//横向滑动音频频道类
<template>
    <div class="view20Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
        <CrossSlip>
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.cover" :name="item.name" :hasNews="item.hasNews" card-type="audio"  @on-click="()=>onAsk(item.id,item.cover,item.name,item.source, item.hasNews)" :key="`tips-quick-${ix}`"/>
        </CrossSlip>
    </div>
</template>


<script>
    import CrossSlip from '../Use/cross-slip-wrapper'
    import BaseCard from '../Use/base-card'
    export default {
        name: 'View20',
        components: {
            CrossSlip,BaseCard
        },
        props: {
            list: {
                type: Array,
                default: []
            },
            tips:{
                type: String,
                default: ''
            },
        },
        methods: {
            onAsk(id,cover,name,source, hasNews) {
                this.$emit("on-show",id, {id,cover,name,source, hasNews}, 9, 'white');
            }
        }
    }
</script>
<style lang="less" scoped>
    .view20Wrapper{

    }

</style>
